import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import colors from 'quasar/src/utils/colors.js';;
import cloneDeep from 'lodash/cloneDeep';
import Logger from 'js-logger';
import { make } from 'vuex-pathify';
import WebFont from 'webfontloader';

var defaultState = function defaultState() {
  return {
    baseFontFamily: [],
    // TODO: Replace images with sensible defaults
    bgImage: '',
    bgImageSetting: 'statics/images/bg-img.png',
    bgImageShare: '',
    logo: '',
    baseTheme: {
      accentColor: '#FA8C46',
      dangerColor: '#D82770',
      greyColor: '#868198',
      logoColor: '#ffde32',
      primaryColor: '#4C378B',
      secondaryColor: '#00AAAA'
    },
    theme: {
      accentColor: '#FA8C46',
      dangerColor: '#D82770',
      fontFamily: 'Poppins',
      gradientColorEnd: '#00AAAA',
      gradientColorStart: '#ffde32',
      greyColor: '#868198',
      iconAdditionalColor: '#18A1A8',
      iconShadowColor: '#BAE2F4',
      logoColor: '#ffde32',
      primaryColor: '#4C378B',
      secondaryColor: '#00AAAA',
      selectedColorShadow: '#E7E3F6',
      unselectedBorderColor: '#FAD282',
      unselectedColor: '#FCE1B1'
    }
  };
};

var state = defaultState();

var getters = _objectSpread({}, make.getters(state));

var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  // Make default mutations

  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  }
});

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  // Make default actions
  updateTheme: function updateTheme(_ref) {
    var commit = _ref.commit,
        state = _ref.state;
    Logger.debug('Update theme');
    var _state$theme = state.theme,
        accentColor = _state$theme.accentColor,
        dangerColor = _state$theme.dangerColor,
        fontFamily = _state$theme.fontFamily,
        iconAdditionalColor = _state$theme.iconAdditionalColor,
        iconShadowColor = _state$theme.iconShadowColor,
        primaryColor = _state$theme.primaryColor,
        secondaryColor = _state$theme.secondaryColor,
        selectedColorShadow = _state$theme.selectedColorShadow,
        unselectedBorderColor = _state$theme.unselectedBorderColor,
        unselectedColor = _state$theme.unselectedColor;

    if (!state.baseFontFamily.includes(fontFamily)) {
      var baseFontFamily = cloneDeep(state.baseFontFamily) || [];
      baseFontFamily.push(fontFamily);
      commit('baseFontFamily', baseFontFamily);
    }

    WebFont.load({
      google: {
        families: state.baseFontFamily
      }
    });
    colors.setBrand('accentColor', accentColor);
    colors.setBrand('iconAdditionalColor', iconAdditionalColor);
    colors.setBrand('iconShadowColor', iconShadowColor);
    colors.setBrand('negative', dangerColor);
    colors.setBrand('primary', primaryColor);
    colors.setBrand('secondary', secondaryColor);
    colors.setBrand('selectedColorShadow', selectedColorShadow);
    colors.setBrand('unselectedBorderColor', unselectedBorderColor);
    colors.setBrand('unselectedColor', unselectedColor);
  }
});

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  namespaced: true
};